"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleWrapper = exports.StyleStoreName = exports.StyleInfo = exports.StyleIcon = exports.StyleGroupName = exports.StyleButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleInfo = exports.StyleInfo = _styledComponents.default.div.withConfig({
  displayName: "StyleInfo",
  componentId: "sc-7v3dfm-0"
})(["flex:1;padding-left:8px;@media ", ",", "{padding-left:0px;}"], _responsive.default.md, _responsive.default.lg);
const StyleGroupName = exports.StyleGroupName = _styledComponents.default.p.withConfig({
  displayName: "StyleGroupName",
  componentId: "sc-7v3dfm-1"
})(["width:100%;overflow:hidden;font-family:Figtree;font-size:16px;font-style:normal;font-weight:400;line-height:24px;letter-spacing:0em;text-align:left;color:", ";@media ", "{white-space:nowrap;text-overflow:ellipsis;max-width:240px;}"], (0, _color.default)('gray-2'), _responsive.default.lg);
const StyleStoreName = exports.StyleStoreName = _styledComponents.default.div.withConfig({
  displayName: "StyleStoreName",
  componentId: "sc-7v3dfm-2"
})(["display:flex;justify-content:flex-start;p{font-family:Figtree;font-size:14px;font-style:normal;font-weight:600;line-height:150%;letter-spacing:0em;color:", ";max-width:240px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;margin-right:8px;@media ", "{max-width:214px;}}@media ", "{max-width:240px;justify-content:flex-end;}"], (0, _color.default)('gray-1'), _responsive.default.lg, _responsive.default.lg);
const StyleButton = exports.StyleButton = _styledComponents.default.div.withConfig({
  displayName: "StyleButton",
  componentId: "sc-7v3dfm-3"
})(["display:flex;line-height:1.4em;transition:color 0.3s;font-size:1.4rem;"]);
const StyleWrapper = exports.StyleWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyleWrapper",
  componentId: "sc-7v3dfm-4"
})(["&:hover{color:", ";}width:100%;@media ", "{width:unset;border-right:1px solid #d6d6de;padding-right:24px;}"], (0, _color.default)('#43bccd'), _responsive.default.lg);
const StyleIcon = exports.StyleIcon = _styledComponents.default.img.withConfig({
  displayName: "StyleIcon",
  componentId: "sc-7v3dfm-5"
})(["width:20px;height:20px;"]);